import DisabledComment from './DisabledComment';
export default DisabledComment;
